import api from "./api";
import { BankStatement, StatementAnalysis } from "@/types/statement";

export const statementService = {
  getByBorrowerId: async (borrowerId: number): Promise<BankStatement[]> => {
    const response = await api.get<BankStatement[] | { results: BankStatement[] }>(`/statements/`, {
      params: { borrower_id: borrowerId },
    });
    const data = response.data;
    return Array.isArray(data) ? data : (data?.results ?? []);
  },

  getById: async (id: number): Promise<BankStatement> => {
    const response = await api.get<BankStatement>(`/statements/${id}/`);
    return response.data;
  },

  getAnalysis: async (statementId: number): Promise<StatementAnalysis> => {
    const response = await api.get<StatementAnalysis>(`/statements/${statementId}/analysis/`);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/statements/${id}/`);
  },

  reprocess: async (id: number): Promise<BankStatement> => {
    const response = await api.post<BankStatement>(`/statements/${id}/reprocess/`);
    return response.data;
  },

  download: async (id: number): Promise<string> => {
    const { data } = await api.get<{ url: string }>(`/statements/${id}/download/`);
    return data.url;
  },
};
